const thumbSize = 15;
document.querySelectorAll('[data-input="range"]').forEach(range => {
  range.addEventListener('input', (e) => {
    let width = (e.target.value - e.target.min) / (e.target.max - e.target.min) * 100;
    let offset = (width - 50) * -0.02 * thumbSize;
    e.target.parentElement.querySelector(".range-active-track").style.width = "calc(" + width + "% + " + offset + "px)";
    e.target.parentElement.querySelector(".range-thumb").style.left = "calc(" + width + "% + " + offset + "px)";
  });
  let width = (range.value - range.min) / (range.max - range.min) * 100;
  let offset = (width - 50) * -0.02 * thumbSize;
    range.parentElement.querySelector(".range-active-track").style.width = "calc(" + width + "% + " + offset + "px)";
    range.parentElement.querySelector(".range-thumb").style.left = "calc(" + width + "% + " + offset + "px)";
})
